import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'

import { InputField, SelectField } from '../../components/inputs'
import { AccessibleOrganizationsSelect } from '../../components/inputs/accessibleOrganizationsSelect'
import LoaderButton from '../../components/loaderButton'
import { ReduxFormProps } from '../../forms'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  clearFields?: Callback
  clear: Callback
  cancel: Callback
}

export interface FormProps {
  name: string
  productPackage: string
  currentAdmin: string
}

export class UserFilterForm extends Component<
  ReduxFormProps<Props, FormProps>
> {
  static displayName = 'UserFilterForm'

  render() {
    const { handleSubmit, submitting, clear, cancel } = this.props

    return (
      <form
        className="form index-filter__form"
        name="UserFilterForm"
        onSubmit={handleSubmit}
      >
        <div
          className="filter"
          // disabled={submitting} // TODO-TS
        >
          <div>
            <h2 className="filter__header">Customer Name</h2>
            <hr className="form__hr  filter__hr" />
            <Field
              type="text"
              label="Enter a Customer name"
              name="name"
              data-testid="user-filter-form-customer-name-input"
              component={InputField}
              gridClass="filter__field"
            />
          </div>

          <div>
            <h2 className="filter__header">Status</h2>
            <hr className="form__hr filter__hr" />

            <Field
              label="Select a status"
              name="productPackage"
              component={SelectField}
              gridClass="field filter__field"
              data-testid="user-filter-form-product-package-status-option"
            >
              <option value="">No status selected</option>
              <option value="empty">Empty</option>
              <option value="quoted">Quoted</option>
              <option value="selected">Selected</option>
              <option value="booked">Booked</option>
              <option value="payment_succeeded">Payment Succeeded</option>
              <option value="payment_failed">Payment Failed</option>
              <option value="agreement_signed">Agreement Signed</option>
              <option value="payment_agreement_signed">Payment Agreement Signed</option>
              <option value="product_agreement_signed">Product Agreement Signed</option>
              <option value="remitted">Remitted</option>
              <option value="cancelled">Cancelled</option>
              <option value="back_out">Back Out</option>
              <option value="product_remitted_error">Product Remitted Error</option>
              <option value="payment_remitted_error">Payment Remitted Error</option>
              <option value="product_and_payment_remitted_error">Product And Payment Remitted Error</option>
              
            </Field>
          </div>

          <div>
            <h2 className="filter__header">Agent Name</h2>
            <hr className="form__hr  filter__hr" />
            <Field
              type="text"
              label="Enter an Agent name"
              name="currentAdmin"
              data-testid="user-filter-form-agent-name-input"
              component={InputField}
              gridClass="filter__field"
            />
          </div>

          <div>
            <h2 className="filter__header">Organizations</h2>
            <hr className="form__hr filter__hr" />
            <AccessibleOrganizationsSelect
              label="Select organizations"
              name="organizations"
            />
          </div>

          <hr className="form__hr  filter__button-hr" />
          <div className="form__group filter__buttons">
            <LoaderButton
              type="submit"
              className="button button--primary filter__button--apply"
              isLoading={submitting}
              data-testid="user-filter-form-apply-button"
            >
              Apply
            </LoaderButton>
            <a
              onClick={clear}
              className="button button--secondary filter__button--reset"
              aria-label="Clear"
              data-testid="user-filter-form-apply-link"
            >
              Clear
            </a>
          </div>
          <a
            onClick={cancel}
            className="button button-link-text filter__cancel"
            data-testid="user-filter-form-cancel-link"
          >
            Cancel
          </a>
        </div>
      </form>
    )
  }
}

export const validate = (data) => {
  const { name, currentAdmin } = data
  const errors: Partial<FormProps> = {}

  if (!/^[a-zA-Z\s]*$/.test(name)) {
    errors.name = 'Only letters are allowed'
  }

  if (!/^[a-zA-Z\s]*$/.test(currentAdmin)) {
    errors.currentAdmin = 'Only letters are allowed'
  }

  return errors
}

export default reduxForm<FormProps, Props>({
  form: 'userFilterForm',
  validate,
  enableReinitialize: false,
  destroyOnUnmount: true,
})(UserFilterForm)
